import { h } from 'preact'
import { localised } from '~core/localisation'
import { asyncComponent } from '~utils/components'
import Spinner from 'components/Spinner'
import { Header } from './Header'

import type { RenderFallbackProp, StepComponentProps } from '~types/routers'
import FallbackButton from 'components/Button/FallbackButton'

const Loader = localised(({ translate }) => (
  <Header
    title={translate('generic.loading')}
    // TODO: Needs translations
    // subtitle="This should take less than a minute"
  >
    <Spinner floating={false} />
  </Header>
))

const ActiveVideo = asyncComponent(
  () => import(/* webpackChunkName: "activeVideo" */ './ActiveVideo'),
  Loader
)

const LazyActiveVideo = (props: StepComponentProps) => {
  const { changeFlowTo } = props
  const renderCrossDeviceFallback: RenderFallbackProp = ({ text }) => {
    return (
      <FallbackButton
        text={text}
        onClick={() => changeFlowTo('crossDeviceSteps')}
      />
    )
  }

  return (
    <ActiveVideo
      renderCrossDeviceFallback={renderCrossDeviceFallback}
      {...props}
    />
  )
}

export default localised(LazyActiveVideo)
